import { getTranslation } from "../utils/translations";
import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import logo from "../assets/logos/hospitality-logo.png";
import "../App.css";

export default function HospitalityHeader() {
  const { user, token, logout } = useAuth();
  const navigate = useNavigate();
  const { lang, setLang } = useContext(LanguageContext);
  const t = getTranslation(lang);

  const handleLogout = () => {
    logout();
    navigate("/hospitality");
  };

  return (
    <header style={headerStyle}>
      {/* Left: Logo */}
      <Link to="/hospitality" style={logoLinkStyle}>
        <img src={logo} alt="Hospitality Logo" className="hospitality-logo" />
      </Link>


      {/* Right: Auth Buttons */}
      <div style={authContainerStyle}>

        {/* 🌍 Language Selector */}
        <select
          value={lang}
          onChange={(e) => setLang(e.target.value)}
          style={languageSelectStyle}
        >
          <option value="en">EN</option>
          <option value="es">ES</option>
          <option value="fr">FR</option>
          <option value="de">DE</option>
          <option value="am">AM</option>
        </select>

        {!token ? (
          <>
            <Link to="/hospitality/login" style={loginButtonStyle}>
              {t.hospitality_header?.login}
            </Link>
            <Link to="/hospitality/register" style={registerButtonStyle}>
              {t.hospitality_header?.register}
            </Link>
          </>
        ) : (
          <>
            <span style={welcomeTextStyle}>
              {t.hospitality_header?.welcome}, {user?.name ? user.name.split(" ")[0] : "Guest"}!
            </span>
            <button onClick={handleLogout} style={logoutButtonStyle}>
              {t.hospitality_header?.logout}
            </button>
          </>
        )}
      </div>
    </header>
  );
}

/* ------------------- Styles ------------------- */
const headerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "15px 20px",
  backgroundColor: "#1c1917",
  boxShadow: "0 2px 6px rgba(0,0,0,0.25)",
  position: "sticky",
  top: 0,
  zIndex: 1000,
  flexWrap: "wrap",
};

const logoLinkStyle = {
  display: "flex",
  alignItems: "center",
  textDecoration: "none",
  flex: "0 0 auto",
};

const logoStyle = {
  width: "120px",
  height: "auto",
};

const titleContainerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: "1 1 auto",
  minWidth: 0,
};

const mainTitleStyle = {
  color: "#ff33cc",
  fontSize: "1.5rem",
  fontWeight: 700,
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const subTitleStyle = {
  color: "#f2c1e0",
  fontSize: "1rem",
  fontWeight: 500,
  marginTop: "4px",
  textAlign: "center",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const authContainerStyle = {
  display: "flex",
  flexWrap: "wrap",
  gap: "8px",
  alignItems: "center",
  flex: "0 0 auto",
  marginTop: "8px", // for small screens wrapping
};

const welcomeTextStyle = {
  color: "#fff",
  fontWeight: 500,
};

const buttonBaseStyle = {
  padding: "8px 14px",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  fontWeight: 500,
  textDecoration: "none",
  color: "#fff",
  whiteSpace: "nowrap",
};

const loginButtonStyle = {
  ...buttonBaseStyle,
  backgroundColor: "#f97316",
};

const registerButtonStyle = {
  ...buttonBaseStyle,
  backgroundColor: "#22c55e",
};

const logoutButtonStyle = {
  ...buttonBaseStyle,
  backgroundColor: "#dc2626",
};

const languageSelectStyle = {
  padding: "6px 8px",
  borderRadius: "6px",
  border: "none",
  fontWeight: 600,
  cursor: "pointer",
};